import { ControllerContract } from '../architecture/ControllerContract';

export class PublicApiError extends Error {
    readonly status: number;

    constructor(
        controllerContract: ControllerContract,
        endpoint: string,
        rawResponse: Response
    ) {
        super(
            `Endpoint ${controllerContract.controllerPath}/${endpoint} returned an error: ${rawResponse.statusText}`
        );
        this.status = rawResponse.status;
    }
}
